module.exports = __webpack_public_path__ + "img/logo-customer-service.e8940115.svg";